/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What shorter words can you spell from SILENT?`)
};

const es_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué palabras más cortas puedes formar con SILENT?`)
};

const de_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche kürzeren Wörter kannst du aus SILENT bilden?`)
};

const nl_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke kortere woorden kun je spellen uit SILENT?`)
};

const fr_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels mots plus courts peut-on former à partir de SILENT ?`)
};

const it_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali parole più corte puoi formare da SILENT?`)
};

const pt_br2_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais palavras mais curtas você pode formar a partir de SILENT?`)
};

const pt_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que palavras mais curtas se podem soletrar a partir de SILENT?`)
};

const ja_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENTから綴れる短い単語は何ですか？`)
};

const zh_wu_c_silent_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 SILENT 能拼出哪些较短的单词？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_silent_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_silent_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_silent_faq2_q", locale)
	if (locale === "en") return en_wu_c_silent_faq2_q(inputs)
	if (locale === "es") return es_wu_c_silent_faq2_q(inputs)
	if (locale === "de") return de_wu_c_silent_faq2_q(inputs)
	if (locale === "nl") return nl_wu_c_silent_faq2_q(inputs)
	if (locale === "fr") return fr_wu_c_silent_faq2_q(inputs)
	if (locale === "it") return it_wu_c_silent_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_silent_faq2_q(inputs)
	if (locale === "pt") return pt_wu_c_silent_faq2_q(inputs)
	if (locale === "ja") return ja_wu_c_silent_faq2_q(inputs)
	return zh_wu_c_silent_faq2_q(inputs)
};